//import { createRouter, createWebHistory } from 'vue-router';
import { createRouter, createWebHashHistory } from 'vue-router'
import DefaultLayout from '../layouts/DefaultLayout.vue'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import Shop from '../views/pages/shop.vue'
import Search from '../views/pages/search.vue'
import Cart from '../views/pages/cart.vue'
import Checkout from '../views/pages/checkout.vue'
import Login from '../views/pages/login.vue'
import MyAccount from '../views/pages/my-account.vue'
import MyOrder from '../views/pages/my-orders.vue'
import MyOrderDetails from '../views/pages/my-order-details.vue'
import MyAddress from '../views/pages/my-address.vue'
import ProductDetails from '../views/pages/shop-details/index.vue'


const routes = [
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
        meta: {
          title: 'Home',
          description: 'Welcome to our home page. Explore the best mobile phones.',
          keywords: 'mobile phones, electronics, best deals',
        },
      },
      {
        path: 'about',
        name: 'About',
        component: About,
        meta: {
          title: 'About Us',
          description: 'Learn more about our company and values.',
          keywords: 'about us, company, mobile store',
        },
      },
      {
        path: 'shop',
        name: 'Shop',
        component: Shop,
        meta: { title: 'Shop' },
      },
      {
        path: 'search',
        name: 'Search',
        component: Search,
        meta: { title: 'Search' },
      },
      {
        path: 'cart',
        name: 'Cart',
        component: Cart,
        meta: { title: 'Your Cart' },
      },
      {
        path: 'checkout',
        name: 'Checkout',
        component: Checkout,
        meta: { title: 'Checkout' },
      },
      {
        path: 'login',
        name: 'Login',
        component: Login,
        meta: { title: 'Login' },
      },
      {
        path: 'my-account',
        name: 'MyAccount',
        component: MyAccount,
        meta: { title: 'My Account' },
      },
      {
        path: 'my-orders',
        name: 'MyOrders',
        component: MyOrder,
        meta: { title: 'My Orders' },
      },
      {
        path: '/order/:id',
        name: 'OrderDetails',
        component: MyOrderDetails,
        props: true,
        meta: { title: 'Order Details' },
      },
      {
        path: 'my-address',
        name: 'MyAddress',
        component: MyAddress,
        meta: { title: 'My Address' },
      },
      {
        path: 'contact',
        name: 'Contact',
        component: Contact,
        meta: { title: 'Contact Us' },
      },
      {
        path: '/product-details/:id',
        name: 'ProductDetails',
        component: ProductDetails,
        props: true,
        meta: { title: 'Product Details' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

// Dynamically set the page title using settings store
router.beforeEach((to, from, next) => {
  const defaultTitle = 'Laser Mobile Phone Arcade'
  const webName = defaultTitle

  // Set page title
  document.title = to.meta.title ? `${to.meta.title} - ${webName}` : webName

  // Set meta description
  const description = to.meta.description || 'Default description for the website.'
  let descriptionTag = document.querySelector('meta[name="description"]')
  if (!descriptionTag) {
    descriptionTag = document.createElement('meta')
    descriptionTag.setAttribute('name', 'description')
    document.head.appendChild(descriptionTag)
  }
  descriptionTag.setAttribute('content', description)

  // Set meta keywords
  const keywords = to.meta.keywords || 'default, keywords'
  let keywordsTag = document.querySelector('meta[name="keywords"]')
  if (!keywordsTag) {
    keywordsTag = document.createElement('meta')
    keywordsTag.setAttribute('name', 'keywords')
    document.head.appendChild(keywordsTag)
  }
  keywordsTag.setAttribute('content', keywords)


  // Authentication check for the Checkout page
  const isAuthenticated = localStorage.getItem('auth_token') // Check if user is logged in

  if (to.name === 'Checkout' && !isAuthenticated) {
    next({ name: 'Login' }) // Redirect to login if user is not authenticated
  } else {
    next() // Proceed normally
  }
})


export default router
